import MainContainer from 'components/generic/MainContainer'
import UserMessageScreen, {
  Props as UserMessageScreenProps,
} from 'components/generic/UserMessageScreen'
import { MessageTypes, MESSAGE_SCREENS } from 'constants/message-screens'
import React from 'react'
import styles from './userMessageFullScreen.module.scss'
import classNames from 'classnames'
import ErrorScreen from 'components/generic/ErrorScreen'
import { getQueryParam, isCurrentPageOneOf } from 'utils'

type Props = UserMessageScreenProps & {
  messageType: MessageTypes
  error?: Error
}

const UserMessageFullScreen = ({ messageType = MessageTypes.DEFAULT, error, ...props }: Props) => {
  const errorDescription = isCurrentPageOneOf(['ERROR'])
    ? getQueryParam('description') || '--'
    : null
  const errorMessage = error ? error?.message : errorDescription

  return (
    <MainContainer>
      <div className={classNames(styles.innerPagePadding, styles.minHeightFull)}>
        {errorMessage ? (
          <ErrorScreen type={messageType} message={errorMessage} {...props} />
        ) : (
          <UserMessageScreen {...MESSAGE_SCREENS[messageType]} {...props} />
        )}
      </div>
    </MainContainer>
  )
}

export default UserMessageFullScreen
